export default __webpack_public_path__ + "static/cafe_36025-54032eea6244ad6edb9ab68a3792cdb1.png";